export const Loader: React.FC = () => {
  return (
    <div className="lds-spinner" role="status">
      {Array.from({ length: 12 }).map((_, key) => (
        <div key={key} />
      ))}
    </div>
  );
};
